import React from 'react';
import { Check } from 'lucide-react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function IncludedSection() {
  const {
    ref,
    isRevealed
  } = useScrollReveal();
  const items = ['Custom Premium Design', 'Fully Responsive Layout', 'SEO Optimization Basic', 'Fast Secure Hosting', 'Domain Name Setup', 'Content Integration', 'Contact Forms & Maps', 'Google Analytics Setup', '3 Rounds of Revisions', 'Delivery in 48 Hours'];
  return <section id="included" className="py-24 md:py-32 relative bg-[#080808]" data-id="element-147">
      <div className="container mx-auto px-4 md:px-6" data-id="element-148">
        <div className="flex flex-col md:flex-row gap-12 md:gap-20 items-center" data-id="element-149">
          <div className="w-full md:w-1/2" data-id="element-150">
            <div ref={ref} className={`transition-all duration-1000 ${isRevealed ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'}`} data-id="element-151">
              <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-152">
                Everything You Need <br data-id="element-153" />
                <span className="text-[#c9a84c]" data-id="element-154">In One Package</span>
              </h2>
              <p className="text-gray-400 text-lg mb-8" data-id="element-155">
                No hidden fees. No complicated tiers. Just one comprehensive
                package designed to get your business online with style.
              </p>
              <div className="h-1 w-20 bg-[#c9a84c] rounded-full" data-id="element-156"></div>
            </div>
          </div>

          <div className="w-full md:w-1/2" data-id="element-157">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-6" data-id="element-158">
              {items.map((item, index) => <IncludedItem key={index} text={item} delay={index * 100} data-id="element-159" />)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}
function IncludedItem({
  text,
  delay
}: {
  text: string;
  delay: number;
}) {
  const {
    ref,
    isRevealed
  } = useScrollReveal();
  return <div ref={ref} style={{
    transitionDelay: `${delay}ms`
  }} className={`flex items-center gap-3 transition-all duration-500 ${isRevealed ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-5'}`} data-id="element-160">
      <div className="h-2 w-2 rounded-full bg-[#c9a84c] shadow-[0_0_8px_rgba(201,168,76,0.8)] flex-shrink-0" data-id="element-161" />
      <span className="text-gray-300 font-medium" data-id="element-162">{text}</span>
    </div>;
}